import { FC, useState } from "react";
import { Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { atom, useAtomValue, useSetAtom } from 'jotai';

// common
import { ActionCB } from "@common/type_defs";
import { defs, } from "@common/const_defs";
import { ContactUsData, newContactUsData } from "@data/contact-us";

// component
import ModalDialog from "@cmpt/molecular/ModalDialog";
import ContactUsPanel from "./components/ContactInputPanel";

type DlgContactUs = {
  isShow: boolean;
  data: ContactUsData;
  onAction?: ActionCB;
}
export const daDlgContactUs = atom<DlgContactUs>({ isShow: false, data: newContactUsData(), onAction: undefined });
export const handleOpenDlgContactUs = atom(null, (get, set, actHandler: ActionCB) => {
  set(daDlgContactUs, { isShow: true, data: newContactUsData(), onAction: actHandler });
})
export const handleCloseDlgContactUs = atom(null, (get, set) => {
  const stat = get(daDlgContactUs);
  set(daDlgContactUs, { ...stat, isShow: false });
})

function getDefWidth(): number {
  let w = 780;
  if (window.innerWidth < (w - 100)) {
    w = window.innerWidth - 100;
  }
  return w;
}
function getDefHeight(): number {
  let dm = 520;
  if (window.innerHeight < (dm - 100)) {
    dm = window.innerHeight - 100;
  }
  return dm;
}

type ContactUsProps = {
  onAction: ActionCB;
};
const ContactUsDialog: FC<ContactUsProps> = ({ onAction, }) => {
  const stat = useAtomValue(daDlgContactUs);
  const closeDlg = useSetAtom(daDlgContactUs);
  const [curData, setCurData] = useState<ContactUsData>(newContactUsData());
  const handleAction: ActionCB = (act, vd) => {
    if (act === "cancel") {
      closeDlg({ ...stat, isShow: false })
    } else {
      onAction(act, vd);
    }
  };
  const doClose = (reason: string) => {
    closeDlg({ ...stat, isShow: false })
  }

  return (
    <>
      <ModalDialog
        open={stat.isShow}
        title="お問い合わせ"
        content={
          <ContactUsPanel
            data={curData}
            onAction={handleAction}
          />
        }
        buttons={<Grid
          container
          justifyContent="center"
          spacing={2}
        >
          <Grid>
            <Button variant="contained" onClick={() => onAction(defs.kAct_ViewContactUsCancel)}>
              Cancel
            </Button>
          </Grid>
          <Grid>
            <Button variant="contained" type="submit" form="form-contact-us">
              送信
            </Button>
          </Grid>
        </Grid>
        }
        onClose={doClose}
        defWidth={getDefWidth()}
        defHeight={getDefHeight()}
      />
    </>
  );
};

export default ContactUsDialog;
export { ContactUsDialog };
